/**
 * NotificationService — fetches pod-member collection activity from the proxy server.
 * Follows the same pattern as ActivityService (x-tracker-user-id + optional Clerk JWT).
 */

function getApiBase() {
    const proxyUrl = typeof import.meta !== 'undefined' && import.meta.env?.VITE_PROXY_URL;
    return proxyUrl ? `${proxyUrl.replace(/\/+$/, '')}/api` : '/api';
}

export default class NotificationService {
    constructor(trackerUserId, getToken) {
        this._userId = trackerUserId;
        this._getToken = getToken;
        this._apiBase = getApiBase();
    }

    async _headers() {
        const h = { 'x-tracker-user-id': this._userId };
        if (this._getToken) {
            try {
                const token = await this._getToken();
                if (token) h['Authorization'] = `Bearer ${token}`;
            } catch (_) { /* fall back to x-tracker-user-id */ }
        }
        return h;
    }

    /**
     * Fetch recent collection additions by pod members.
     * @param {'books'|'movies'|'games'|'boardgames'} appType
     * @returns {Promise<{ notifications: Array }>}
     */
    async fetch(appType) {
        const res = await fetch(
            `${this._apiBase}/notifications?appType=${encodeURIComponent(appType)}`,
            { headers: await this._headers() },
        );
        if (!res.ok) {
            const data = await res.json().catch(() => ({}));
            throw new Error(data.error || `Failed to fetch notifications: ${res.status}`);
        }
        return res.json();
    }
}
